var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FormBaseElement } from '@unitarius/xbpm-runtime';
import { mapElementClass } from '../../common/utils/element.utils';
import { ControlError } from './ControlError';
import { Paginator } from 'primereact/paginator';
var PaginatorControl = /** @class */ (function (_super) {
    __extends(PaginatorControl, _super);
    function PaginatorControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (target, value) { return function (_a) {
            var first = _a.first, rows = _a.rows;
            _this.handleChange(__assign(__assign({}, value), { index: first, rows: rows }));
            var type = target.actionButton;
            if (type) {
                _this.props.onEvent({ type: type, target: target });
            }
        }; };
        return _this;
    }
    PaginatorControl.prototype.elementRender = function (def) {
        var frontOptions = def.frontOptions, rowsPerPage = def.frontOptions.rowsPerPage;
        var rowsPerPageOptions = [10];
        if (typeof rowsPerPage === 'string') {
            var arrayString = rowsPerPage.match(/\d+/g);
            rowsPerPageOptions = arrayString.length ? arrayString.map(function (el) { return parseInt(el, 10); }) : rowsPerPageOptions;
        }
        var value = __assign({ index: 0, totalRecords: 0, rows: rowsPerPageOptions[0] }, this.value || {});
        var index = value.index, totalRecords = value.totalRecords, rows = value.rows;
        return def.hidden ? (null) : React.createElement("div", { className: mapElementClass(frontOptions) },
            React.createElement(Paginator, { first: index, totalRecords: totalRecords < rows ? index + rows : totalRecords, rows: rows, rowsPerPageOptions: rowsPerPageOptions, onPageChange: this.onChange(def, value) }),
            React.createElement(ControlError, { error: this.error, touched: this.touched }));
    };
    ;
    return PaginatorControl;
}(FormBaseElement));
export { PaginatorControl };
//# sourceMappingURL=Paginator.js.map